import { Link } from "react-router-dom";
import { ArrowRight, ListChecks, Leaf } from "lucide-react";

export const TWO_WEEK_PATH = "/guides/two-week-emergency-checklist";

export function FeaturedChecklistCard({ compact = false, testid = "featured-two-week-card" }) {
  if (compact) {
    return (
      <Link to={TWO_WEEK_PATH} data-testid={testid} className="group flex items-center gap-3 rounded-xl border border-slate-200 bg-white p-4 hover:border-navy transition-colors focus-visible:ring-2 focus-visible:ring-royal">
        <ListChecks className="h-6 w-6 shrink-0 text-green-700" aria-hidden="true" />
        <span className="min-w-0">
          <span className="block label-caps text-slate-500">Evergreen preparedness guidance</span>
          <span className="block font-semibold text-navy leading-snug">Two week emergency food and essentials checklist</span>
        </span>
        <ArrowRight className="ml-auto h-4 w-4 shrink-0 text-slate-400 transition-transform group-hover:translate-x-0.5" aria-hidden="true" />
      </Link>
    );
  }
  return (
    <article data-testid={testid} className="relative overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
      <div className="absolute inset-y-0 left-0 w-1.5 bg-green-700" aria-hidden="true" />
      <div className="grid gap-6 p-6 sm:p-8 md:grid-cols-[1fr_auto] md:items-center">
        <div>
          <div className="flex flex-wrap items-center gap-2">
            <span data-testid={`${testid}-badge`} className="rounded-full bg-navy px-3 py-1 text-xs font-bold uppercase tracking-wide text-white">Featured guide</span>
            <span className="inline-flex items-center gap-1 rounded-full bg-green-100 px-3 py-1 text-xs font-semibold text-green-800"><Leaf className="h-3.5 w-3.5" aria-hidden="true" /> Evergreen preparedness guidance</span>
          </div>
          <h2 className="mt-3 font-heading font-extrabold text-2xl sm:text-3xl text-navy leading-tight">Two week emergency food and essentials checklist</h2>
          <p className="mt-2 text-base sm:text-lg text-slate-600 max-w-2xl">Work out what your household would need for two weeks, check what you already have and build your supplies gradually.</p>
        </div>
        <Link to={TWO_WEEK_PATH} data-testid={`${testid}-cta`} className="touch justify-center gap-2 rounded-lg bg-navy px-6 py-4 text-base font-bold text-white hover:bg-navy-800 transition-colors focus-visible:ring-2 focus-visible:ring-royal focus-visible:ring-offset-2">
          View the checklist <ArrowRight className="h-5 w-5" aria-hidden="true" />
        </Link>
      </div>
    </article>
  );
}
